import { makeAutoObservable } from "mobx";
import { ProgStatus } from "../models/utilTypes";
import ApiService from "../services/ApiService";
import { rootStore } from "../StApp";
import { RootStore } from "./RootStore";

export class InviteStore{

    instagram: string = ''
    linkedIn: string = ''
    inviteCode: string = ''
    createInviteProg: ProgStatus = 'INIT'
    leftInvites: number = 0

    constructor(){
        makeAutoObservable(this)
    }

    createInvite(){
        this.createInviteProg = 'LOADING'
        ApiService.createInviteRequest({
            auth: rootStore.mainStore.token,
            data: {
                uid: rootStore.mainStore.uid!,
                ig: this.instagram,
                linked_in: this.linkedIn,
                video: false
            }
        }).then(resp=>{
            this.createInviteProg = 'SUCCESS'
            this.inviteCode = resp.data.invite
            this.leftInvites = resp.data.leftInvites
        })
    }

    getLeftInvites(){
        ApiService.getMyProfile().then(resp=>{
            this.leftInvites = resp.data.leftInvites!
        })
    }

    updateInstagram(data: string){
        this.instagram = data
    }

    updateLinkedIn(data: string){
        this.linkedIn = data
    }
}